import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerService } from '../../retailers/retailer.service';
import { ManageUserService } from '../manage-user.service';

@Component({
  selector: 'app-edit-user-smart',
  template: `<app-edit-user [roles]="roles" [salespricelists]="salespricelists" [businessnames]="businessnames" [userDetail]="userDetail" [userId]="userId"></app-edit-user>`,
  styles: [
  ]
})
export class EditUserSmartComponent extends FeaturesBaseComponent implements OnInit {
  businessnames: any[] =[];
  salespricelists: any[] =[];
  roles: any[] =[];
  userId: number;
  userDetail: any;

  constructor(private activeRoute: ActivatedRoute,private retailerService: RetailerService, private manageUserService: ManageUserService) {
    super();
    this.userId =this.activeRoute.snapshot.params.id;
    this.getAllData()

  }

  getAllData() {
    let getBusinessnamesData = this.retailerService.getBusinessnames();
    let getslaesPricelistData = this.retailerService.getsalesPricelists(); 
    let getUserByid = this.manageUserService.getUserbyId(this.userId);
    let getRoles = this.retailerService.getRoles();
    forkJoin([getBusinessnamesData,getslaesPricelistData, getUserByid, getRoles]).subscribe(
      res => {
        this.businessnames = res[0]['data'];
        this.salespricelists = res[1]['data'];
        this.userDetail = res[2]['data'];
        this.roles = res[3]['data'];
      }
    )

  }

  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnDestroy(){
    super.ngOnDestroy()
  }

}
